import Swiper, {Navigation} from 'swiper';

const options = {
    modules      : [Navigation],
    loop         : false,
    speed        : 800,
    spaceBetween : 32,
    slidesPerView: 'auto',
    navigation   : {
        nextEl: '.j-projects-next',
        prevEl: '.j-projects-prev'
    }
};

const slider = document.querySelector('.j-projects-slider');
const breakpoint = window.matchMedia('(min-width:1280px)');

const initSlider = () => {
    return new Swiper(slider, options);
};

const breakpointChecker = () => {
    if (breakpoint.matches) {
        const swiper = initSlider();

        if (swiper.slides.length >= 2) {
            swiper.navigation.destroy();
        }
    }
};

const initProjectsListSlider = () => {
    if (!slider) {
        return;
    }

    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
};

export {initProjectsListSlider};
